import { toast } from 'react-toastify'

import { toastProps } from 'utils/types/toast-props'

// Shared utility to fetch the CSV URL for a given report endpoint
// Expects a full report URL like: https://api.clientbase.com.br/v1/reports/:uuid/excel
export const fetchReportData = async (
  reportUrl: string
): Promise<string | null> => {
  try {
    const { parseCookies } = await import('nookies')
    const { ['nextauth.token']: token } = parseCookies()

    const response = await fetch(reportUrl, {
      headers: {
        ...(token && { Authorization: `Bearer ${token}` })
      }
    })

    if (!response.ok) {
      throw new Error('Erro ao carregar o relatório')
    }

    const data = await response.json()

    if (data.error) {
      toast.error(data.message, toastProps)
      return null
    }

    if (data.record?.url) {
      return data.record.url
    }

    throw new Error('URL do CSV não encontrada no relatório')
  } catch (error) {
    console.error('Erro ao buscar dados do relatório:', error)
    toast.error('Erro ao carregar o relatório', toastProps)
    return null
  }
}
